
import { GetDirectDebt } from "./types";
import { baseUrl } from "../../base-api";
import { handleSubModuleError } from "../../tools/apiError";
import { ApiResponse } from "../../tools/types";



export const apiGetDirectDebt = async ({
  externalId,
}: {
  externalId: string;
}): Promise<ApiResponse> => {
  try {
    const { status, data } = await baseUrl.get<GetDirectDebt[]>(
      `applications/${externalId}/ddp-debt`
    );
    return {
      status,
      success: status === 200,
      data
    };
  } catch (error: any) {
    return handleSubModuleError(error);
  }
};

export const apiGetDirectDebtDiscovery = async ({
  loanId,
}: {
  loanId: string;
}): Promise<ApiResponse> => {
  try {
    const { status, data } = await baseUrl.get<GetDirectDebt[]>(
      `loans/${loanId}/ddp/direct-debts`
    );
    return {
      status,
      success: status === 200,
      data
    };
  } catch (error: any) {
    return handleSubModuleError(error);
  }
};
